// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/Users/ryanz/Desktop/projects/front/duoguan/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import TableOutlined from '/Users/ryanz/Desktop/projects/front/duoguan/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import CrownOutlined from '/Users/ryanz/Desktop/projects/front/duoguan/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
export default { DashboardOutlined, TableOutlined, CrownOutlined };
